import React from 'react';
import { FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-[#dbe8f5] bg-gradient-to-b from-[#f7fbff] to-white">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-2 text-2xl text-[var(--brand-ink)]">
              <span className="text-[var(--brand-accent)]">Digitalbookshelf</span>care.com
            </h3>
            <p className="text-sm leading-relaxed text-[var(--text-muted)]">Professional subscription management and after-sales support you can trust.</p>
          </div>

          <div>
            {/* <h4 className="mb-3 text-sm font-semibold uppercase tracking-[0.13em] text-[var(--brand-ink)]">Contact</h4> */}
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              {/* <li className="flex items-center gap-2"><FiMail className="h-4 w-4 text-[var(--brand-accent)]" /> support@Digitalbookshelfhub.net</li> */}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-[0.13em] text-[var(--brand-ink)]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              <li><a href="/" className="transition-colors hover:text-[#2b6cb0]">Home</a></li>
              <li><a href="/faqs" className="transition-colors hover:text-[#2b6cb0]">FAQs</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[#dbe8f5] bg-white/80">
        <div className="mx-auto max-w-7xl px-4 py-4 text-center text-xs text-[var(--text-muted)] sm:px-6 lg:px-8">
          &copy; 2026 Digitalbookshelfcare.com - All rights reserved.
        </div>
      </div>
    </footer>
  );
}
